export interface OS {
  id?: string | null;
  condicionPago?: CondicionPagoClass | null;
  estadoOS?: EstadoOS | null;
  fechaPago?: string | null;
  fechaPagoProgramada?: string | null;
  historialFechaPago?: HistorialFechaPago[] | null;
  monedaTarifa?: MonedaTarifa | null;
  nameProveedor?: string | null;
  numberFile?: string | null;
  fileExtend?: string | null;
  numberOS?: string | null;
  totalGeneral?: number | null;
  objProvider?: ObjProvider;
  nameClient?: NameClient | null;
  servicio?: Servicio | null;
  key?: string | null;
  tipoOrden?: 'Orden de Servicio' | null;
  montoTotal?: number | null;
  ids?: string[] | null;
  isGrouped?: boolean | null;
  idItinerary?: string | null;
  nameEmpresa?: string | null;
  group?: string | null;
  razonSocialProveedor?: string | null;
  codigoReserva?: string | null;
  fechaProceso?: string | null;
  subTotal?: number | null;
  igv?: number | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

interface ObjProvider {
  id?: null | string;
  nombre?: null | string;
}

interface CondicionPagoClass {
  condicionPago?: CondicionPagoEnum | null;
}

interface HistorialFechaPago {
  fechaPago?: Date | null;
  fechaModificacion?: Date | null;
}
interface Servicio {
  fechaOperacion?: null | string;
  fechaPago?: null | string;
  tipoServicio?: null | string;
  categoriaServicio?: null | string;
  idServicio?: string | null;
  servicio?: string | null;
  cantPax?: string | null;
  monto?: number | null;
  moneda?: string | null;
  incluye?: string | null;
  observaciones?: string | null;
}

enum CondicionPagoEnum {
  Postpago = 'POSTPAGO',
  Prepago = 'PREPAGO',
}

enum EstadoOS {
  Anulado = 'ANULADO',
  Confirmed = 'CONFIRMED',
  EnProceso = 'EN PROCESO',
  Procesado = 'PROCESADO',
  Rechazado = 'RECHAZADO',
}

enum NameClient {
  AdventureLife = 'ADVENTURE LIFE',
  ExplorandesReferidas = 'EXPLORANDES REFERIDAS',
  KnowmadAdventures = 'KNOWMAD ADVENTURES',
}

enum MonedaTarifa {
  D = 'D',
  S = 'S',
}
